import React from "react";
import Tabs from "components/tabs";
import Image from "components/image";
import RichText from "components/rich-text";
import clsx from "clsx/lite";

const TabsModule = ({ data: { tabs } }) => (
	<Tabs
		className="w-[98%] lg:w-fit px-3 md:mx-auto md:!justify-start overflow-x-auto my-2"
		tabClassName={clsx("hover:border hover:border-solid md:hover:border-[#828282]",
			"cursor-pointer px-5 py-3 text-base rounded-5 lg:w-[12%] h-44")}
		activeClassName="bg-white border border-[#A4A4A4] rounded-5 bg-[#f9f9f9]"
		contentClassName="mx-5 lg:mx-10 my-10"
		tabs={
			tabs.map(d => ({
				label: <div className="flex flex-col items-center gap-5 justify-center">
					<Image className="w-[65px]" image={d?.icon} />
					<span>{d?.title}</span>
				</div>,
				content: <RichText value={d.content} data={{ center: true }} />
			}))
		}
	/>
);

export default TabsModule;